// extracted by mini-css-extract-plugin
module.exports = {"agreement":"Agreement_agreement__3Xdsc"};